import { render, staticRenderFns } from "./DecimalFormatTable.vue?vue&type=template&id=7dbf3b64"
import script from "./DecimalFormatTable.vue?vue&type=script&lang=ts"
export * from "./DecimalFormatTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports